import { AxiosResponse } from 'axios'
import { Dayjs } from 'dayjs'
import { request } from '../request'
import { Variable } from '@models/api/Variable'
import { PrediccionReportDTO } from '@models/api/PrediccionReportDTO'
import { StationsTemporalType } from '@enums/StationsTemporalType'

function getReportPlanificacionUrl(
  locationUrlParam: string,
  idModel: string,
  variable: string,
  level: string,
  dateOut: Dayjs,
  byMunicipality: boolean,
  radiusKm?: number
) {
  const url = `api/getBoletinData?${locationUrlParam}&date=${dateOut
    .utc()
    .format('YYYY-MM-DD')}&model=${idModel}&out=${dateOut
    .utc()
    .format('HH')}&variable=${variable}&level=${level}`

  /* url += `&byMunicipality=${byMunicipality}`

  if ((radiusKm || radiusKm === 0) && !byMunicipality) {
    url += `&radioKm=${radiusKm}`
  }*/
  byMunicipality // TODO: Quitar
  radiusKm // TODO: Quitar

  return url
}

export const report = {
  getReportPlanificacionData: function (
    lat: string | number,
    lon: string | number,
    idModel: string,
    variable: string,
    level: string,
    dateOut: Dayjs,
    byMunicipality: boolean,
    radiusKm?: number
  ): Promise<AxiosResponse<PrediccionReportDTO>> {
    return request.get(
      getReportPlanificacionUrl(
        `lat=${lat}&lon=${lon}`,
        idModel,
        variable,
        level,
        dateOut,
        byMunicipality,
        radiusKm
      )
    )
  },

  getReportObservacionesVariables: function (): Promise<
    AxiosResponse<Variable[]>
  > {
    return request.get(`api/getBoletinVariables`)
  },

  getReportObservacionesStations: function (
    date: Dayjs,
    type: StationsTemporalType
  ): Promise<AxiosResponse<number[]>> {
    let dateString = date.format('YYYY-MM-DD')
    if (type === StationsTemporalType.DAILY) {
      dateString = date.format('YYYY-MM-DD')
    } else {
      dateString = date.startOf('month').format('YYYY-MM-DD')
    }
    return request.get(
      `api/getAvailableStationsAemet?date=${dateString}&type=${type}`
    )
  },

  getReportObservacionesData: function (
    idStation: number,
    date: Dayjs,
    variable: string,
    type: StationsTemporalType,
    untilNow: boolean
  ): Promise<AxiosResponse<(number | null)[]>> {
    return request.get(
      `api/getBoletinDataObservationsAemet?id_station=${idStation}&date=${date.format('YYYY-MM-DD')}&variable=${variable}&type=${type}&until_now=${untilNow}`
    )
  },

  getReportFWIData: function (
    lat: string | number,
    lon: string | number,
    idModel: string,
    idVariable: string,
    dateOut: Dayjs
  ) {
    const date = dateOut.utc().format('YYYY-MM-DD')
    return request.get(
      `api/getBoletinData?lat=${lat}&lon=${lon}&date=${date}&model=${idModel}&variable=${idVariable}`
    )
  },

  getReportPlanNacionalVariables: function (): Promise<
    AxiosResponse<Variable[]>
  > {
    return request.get(`informe/variablesPNP`)
  },

  getReportPlanNacionalData: function (
    model: string,
    variable: string,
    level: string,
    stat: string,
    datetime: Dayjs,
    province?: string,
    zone?: string
  ): Promise<AxiosResponse<number[]>> {
    const date = datetime.utc().format('YYYY-MM-DD')
    const out = datetime.utc().format('HH')
    let url = `informe/getBPHData?model=${model}&variable=${variable}&level=${level}&stat=${stat}&date=${date}&out=${out}`

    if (province) {
      url += `&prov=${province}`
    }
    if (zone) {
      url += `&zone=${zone}`
    }

    return request.get(url)
  }
}
